import * as request from "../utils/request"
import * as helper from "../utils/helper"
import * as aes from "../utils/aes"

import * as uuid from "../utils/uuid"
import "es6-promise/auto"
import { session_skey, session_qqconnect, session_wechat, session_dummy, session_third, session_pskey } from "@tencent/midas-util"
import * as langs from "../constants/langs"
import * as url from "../utils/url"

export function checkSessionType({ sessionObj }) {
  if (sessionObj instanceof session_third) {
    return "third"
  } else if (sessionObj instanceof session_wechat) {
    return "wechat"
  } else if (sessionObj instanceof session_skey || sessionObj instanceof session_qqconnect || sessionObj instanceof session_pskey) {
    return "qq"
  } else if (sessionObj instanceof session_dummy) {
    return "dummy"
  }
}

export function getWechatBindQQ(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }
    params = helper.extend(
      params,
      {
        friends: 0,
        pf: params.pf,
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1
      },
      aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/ygejcv0sgl",
        data: params,
        type: "post"
      })
      .then(
        res => {
          if (res.ret == 0 && res.isBind === 1 && res.qquin) {
            resolve(res.qquin)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function checkQQUinValid(uin) {
  return uin && /^[1-9]{1}[0-9]{4,10}$/.test(uin)
}

export function getQQNickname(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }

    params = helper.extend(
      {
        cmd: 1,
        pf: params.pf,
        pfkey: "pfkey",
        from_h5: 1,
        from_https: 1
      },
      params
    )

    if (checkQQUinValid(params?.provide_uin)) {
      request
        .ajax({
          url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/wechat_query",
          data: params,
          type: "post"
        })
        .then(
          res => {
            if (res.ret == 0) {
              resolve(decodeURIComponent(res.nick))
            } else {
              reject(res)
            }
          },
          () => {
            reject({
              msg: "timeout"
            })
          }
        )
    } else {
      reject({
        msg: "no param"
      })
    }
  })
}

/**
 * 获取互联登录态的用户信息
 * @param {} params
 * access_token=2655064C6F4563352755C974DB44C5D3
 * oauth_consumer_key=101502376
 * openid=5251FEFB1B140DB27796804CE3443A5C
 * action=get_user_info
 */
export function getQQConnectUserInfo(params) {
  return new Promise((resolve, reject) => {
    request
      .ajax({
        url: "//pay.qq.com/midas/minipay_v2/views/public/qqconnect.php",
        data: {
          action: "get_user_info",
          access_token: params.openkey,
          oauth_consumer_key: params.qqAppid,
          openid: params.openid
        }
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function getQBBalance(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }

    params = helper.extend(
      {
        cmd: 4,
        pf: params.pf,
        pfkey: "pfkey",
        from_h5: 1,
        from_https: 1
      },
      params
    )
    request
      .ajax({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/wechat_query",
        data: params
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve((res.qb_balance + res.qd_balance) / 100)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function isFollowedOfficalWechatAccount(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }

    //?from_https=1&mid=r&ver=v1&app_ip=116.228.88.18&offer_id=1450013518&wx_direct_pay=0&wx_publice_pay=0&pf=qq_m_qq-2001-android-2011-_paypal&pfkey=pfkey&from_h5=1&session_token=E16F9E2C-78F0-420D-8476-D08AD92ED8C71513741216519&r=0.6139649636902242&openid=odFzSjjHexiui0kKI_GcCXT8X7h4&openkey=9_W8sfVSaR0EdUzfHy6FmZhoYmMyJO2f3hN-ufykiPPqUBl701eruZsThABwg5XB-2Os6_-8u9dBjYdPNlbDxR3A&session_id=hy_gameid&session_type=wc_actoken&action=query_follow"
    params = helper.extend(
      {
        // pf: "mds_wechat_qb-pay_html5-html5",
        pfkey: "pfkey",
        from_h5: 1,
        from_https: 1,
        wx_direct_pay: 0,
        wx_publice_pay: 0,
        action: "query_follow",
        format: "jsonp__getUserFollowedOfficalAccount"
      },
      params
    )
    request
      .jsonp({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/mobile_subscribe",
        data: params,
        jsonpCallbackName: "_getUserFollowedOfficalAccount"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.info.is_followed)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function getJifen(params) {
  return new Promise((resolve, reject) => {
    params = helper.extend(
      {
        fun: "jsonp__getJifen"
      },
      params
    )
    request
      .jsonp({
        url: "//jifen.qq.com/cgi-bin/get_balance",
        data: params,
        jsonpCallbackName: "jsonp__getJifen"
      })
      .then(
        res => {
          if (res.ret == 0) {
            resolve(res.balance)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

export function getVmallLotteryTicket(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }

    params = helper.extend(
      {
        pf: "mds_wechat_qb-pay_html5-html5",
        pfkey: "pfkey",
        from_h5: 1,
        from_https: 1,
        cmd: "check_qualify_by_mix",
        productid: "activity_20180702_wc",
        scene_id: "DRM",
        provide_uin: "123456789",
        format: "jsonp__getVmallLotteryTicket"
      },
      params
    )
    request
      .jsonp({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/get_vmall_lottery_ticket",
        data: params,
        jsonpCallbackName: "_getVmallLotteryTicket"
      })
      .then(
        res => {
          if (res.ret == 0 && res.mix_balance > 0 && res.ssp) {
            resolve(true)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 订阅接口
 * action：query[可订阅]|query_subscribe[已订阅]|subscribe[订阅]|cancel[取消订阅]|query_follow[是否关注]
 * @param params ：action|openid|openkey|session_id|session_type|wx_appid|format|pf|pfkey|from_h5|webversion|r|session_token|groups（订阅、取消）
 * @returns {Promise}
 */
export function getSubscribe(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }
    let jsonpCallbackName = "_h5pay" + Math.floor(Math.random() * 1000000)
    params = helper.extend(
      {
        format: "jsonp_" + jsonpCallbackName,
        pf: params.pf || "__mds_wx_qb_resultdy",
        pfkey: "pfkey",
        from_h5: 1,
        webversion: "MidasSubscribe1.0", //version
        r: Math.random(),
        session_token: uuid.generate() + new Date().getTime()
      },
      params
    )

    request
      .jsonp({
        url: "//" + env + "api.unipay.qq.com/v1/r/" + params.offerId + "/mobile_subscribe",
        data: params,
        jsonpCallbackName: jsonpCallbackName
      })
      .then(
        res => {
          if (res.ret === 0) {
            resolve(res.info)
          } else {
            reject(res)
          }
        },
        () => {
          reject({
            msg: "timeout"
          })
        }
      )
  })
}

/**
 * 查询用户是否是vip及等级,已经qb充值折扣额度等
 * @param params
 */
export function getVipGradeAndRechargeQBQuota(params) {
  return new Promise((resolve, reject) => {
    let env = ""
    if (params.sandbox == 1) {
      env = "sandbox."
    } else if (params.sandbox == 2) {
      env = "dev."
    }

    params = helper.extend(
      {
        cmd: 9,
        pf: params.pf,
        pfkey: "pfkey",
        from_h5: 1,
        from_https: 1,
        from: "PC",
        webversion: "h5storeV0.1"
      },
      params
    )
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/1450000490/wechat_query`,
        data: params
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

/**
 * 判断是否7天好友
 * @param params
 * @returns {Promise}
 */
export function isFriendMoreThan7Days(params) {
  return new Promise((resolve, reject) => {
    request
      .ajax({
        url: "//pay.qq.com/cgi-bin/account/ajax_query.cgi",
        data: {
          cmd: 111,
          friend_uin: params.friendUin
        }
      })
      .then(res => {
        if (res.resultcode == 0) {
          if (res.resultinfo.is == 1) {
            resolve(true)
          } else {
            resolve(false)
          }
        } else {
          reject(res)
        }
      })
  })
}

export function isInWhiteList(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    params = helper.extend(
      {
        pf: "mds_wechat_qb-pay_html5.game-html5",
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1
      },
      params,
      aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/mobile_coupons_info`,
        data: params,
        type: "post"
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function followActivity(params) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    params = helper.extend(
      {
        pf: params.pf || "mds_wechat_qb-pay_html5.game-html5",
        pfkey: "pfkey",
        from_https: 1,
        from_h5: 1
      },
      params,
      aes.encrypt(params, ["openid", "openkey", "session_id", "session_type"], params.sandbox)
    )

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/follow_activity`,
        data: params
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function handleFollowActivity(params) {
  return new Promise(resolve => {
    followActivity(params)
      .then(res => {
        resolve(res)
      })
      .catch(() => {
        resolve({
          ret: 0,
          info: { white_list_value: "" }
        })
      })
  })
}

/**
 * 查询点券余额和金币余额
 * @param {*} params.offerId
 * @param {*} params.zoneId 大区
 * @param {*} params.pf 完整的PF
 * @param {*} params.loginState 登录态
 * @param {*} params.sandbox 环境标识
 * @param {*} params.query_type 查询类型，默认查点券game_coin；王者需要查点券和金币ingame_coin|game_coin
 */
export function queryGameCoinBalance(params, extendParams = {}) {
  return new Promise((resolve, reject) => {
    if (params.loginState.session_type == "st_dummy") {
      // 查余额不支持游客登录态
      return reject()
    }

    let env = helper.getCgiEnv(params.sandbox)

    let apiParams = {
      cmd: 30,
      pf: params.pf,
      ...params.loginState,
      query_type: params.query_type || "game_coin",
      zoneid: params.zoneId
    }

    apiParams = Object.assign(apiParams, extendParams)
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: apiParams,
        type: "GET"
      })
      .then(res => {
        if (res && res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

/**
 * 查询第三方登陆态绑定的账号信息
 */
export function queryThirdSessionBindInfo(params, extendParams = {}) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    let apiParams = {
      cmd: 33,
      pf: params.pf,
      ...params.loginState
    }

    apiParams = Object.assign(apiParams, extendParams)
    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: apiParams,
        type: "GET"
      })
      .then(res => {
        if (res && res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function wechatQuery(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)

    let data = Object.assign(params, extendParams)

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/wechat_query`,
        data: data,
        type: "GET"
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

export function getOpenlink(params, extendParams) {
  return new Promise((resolve, reject) => {
    let env = helper.getCgiEnv(params.sandbox)
    let data = {
      offer_id: params.offerId,
      t: +new Date()
    }
    data = Object.assign(data, extendParams)

    request
      .ajax({
        url: `//${env}api.unipay.qq.com/v1/r/${params.offerId}/get_wx_openlink`,
        data: data
      })
      .then(res => {
        if (res.ret == 0) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(reject)
  })
}

// 个人中心权益
export function getRightsInterests({ userAgent }) {
  let storeConfigEnv = url.getParam("store_config_env")
  let env = storeConfigEnv && storeConfigEnv > 0 ? "sandbox." : ""
  let k = ""
  if (userAgent.QQ) {
    k = "qq"
  } else if (userAgent.weixin) {
    k = "weixin"
  } else {
    k = "browser"
  }
  return new Promise((resolve, reject) => {
    request
      .ajax({
        url: `//${env}pay.qq.com${langs.RIGHTS_INTERESTS_URL_PATH}`,
        data: {
          t: +new Date()
        }
      })
      .then(res => {
        let terminalStr = res.qySupportTerminal
        let terminalUa = `${userAgent.iOS ? "ios" : "android"}_${k}`
        res.rightsInterestsList = res.rightsInterestsList
          ?.map(item => {
            return {
              ...item,
              isOpen: item.qyItemSupportTerminal?.indexOf(terminalUa) !== -1
            }
          })
          ?.filter(item => {
            return item.isOpen
          })
        res = {
          ...res,
          isOpen: terminalStr?.indexOf(terminalUa) !== -1 && res.rightsInterestsList?.length > 0
        }
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
